<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import numberMixin from '../../../../mixins/numberMixin';
import ConfirmDialog from '../../../../components/TwConfirmDialog';
import salesTypeEnums from '../../../../variables/ski/pass/sales-type-enums';
import statusEnums from '../../../../variables/ski/pass/status-type-enums';

export default {
  name: 'SkiPassOverview',
  data() {
    return {
      isPriceChanged: false,
      isProductChanged: false,
      isXmlProductChanged: false,
      editProductDialog: false,
      selectedPass: undefined,
      isSearchingForAnotherProduct: false,
      selectedArea: undefined,
      supplierRefs: {},
      editProductPrices: {
        price: undefined,
        priceNet: undefined,
        keyCardGross: undefined,
        keyCardNet: undefined,
        discount: null,
        discountNet: null,
        discountBookFrom: null,
        discountBookTo: null,
      },
      pubnub: null,
      showInactive: false,
    };
  },
  components: {
    ConfirmDialog,
  },
  mixins: [numberMixin],
  filters: {
    formatDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
  },
  created() {
    this.pass.forEach((pass) => {
      this.$set(this.supplierRefs, pass.id, pass.supplierRef);
    });
  },
  mounted() {
    this.loadXmlChannels(4);
    this.loadXmlProducts(4);
    setTimeout(() => {
      /* eslint-disable-next-line */
      this.pubnub = new PubNub({
        publishKey: this.pubnubInfo.publishKey,
        subscribeKey: this.pubnubInfo.subscribeKey,
        uuid: this.user.uuid,
      });

      this.pubnub.addListener({
        message: (m) => {
          let changeMessage = {};
          if (typeof m.message === 'object') {
            changeMessage = m.message;
          } else {
            changeMessage = JSON.parse(m.message);
          }
          this.$set(this.supplierRefs, changeMessage.id, changeMessage.supplierRef);
          this.updateSupplierRefPubnub(changeMessage);
        },
      });

      this.pubnub.subscribe({
        channels: ['skiPassBooking'],
      });
    }, 500);
  },
  computed: {
    ...mapGetters({
      passes: 'skipass/getSkiPasses',
      totalPrice: 'skipass/getSkiPassTotalPrice',
      availablePassProducts: 'skipass/getAvailableSkiPassProducts',
      bookingParticipantsWherePassExist: 'skipass/getBookingParticipantsWherePassesExist',
      participants: 'booking/getParticipantsWithFullName',
      defaultStartDate: 'booking/getMinimumArrivalDateFromBookingStays',
      availableDates: 'booking/getAvailableDates',
      availablePassProductsPersonCategoryHeaders: 'skipass/getAvailableSkiPassProductsPersonCategoryHeaders',
      availableSkiPassProductUsedForChangeProduct: 'skipass/getAvailableSkiPassProductUsedForChangeProduct',
      twentyBookingCustomerUrl: 'booking/getTwentyBookingCustomerUrl',
      defaultAreaId: 'booking/getDefaultAreaId',
      areasWithAllOption: 'skipass/getBookingStayAreasWithAllOption',
      availableNumberOfDays: 'skipass/getAvailableNumberOfDays',
    }),
    ...mapState({
      pass: state => state.skipass.pass.items,
      passLoading: state => state.skipass.pass.itemsLoading,
      passError: state => state.skipass.pass.itemsError,
      passSaveLoading: state => state.skipass.pass.saveLoading,
      passSaveError: state => state.skipass.pass.saveError,
      booking: state => state.booking.booking,
      bookingParticipantsLoading: state => state.booking.participants.itemsLoading,
      bookingParticipantsError: state => state.booking.participants.itemsError,
      user: state => state.app.auth.user,
      pubnubInfo: state => state.app.auth.pubnub,
      availablePassProductsLoading: state => state.skipass.availablePassProducts.itemsLoading,
      availablePassProductsError: state => state.skipass.availablePassProducts.itemsError,
      availablePassProductsSaveLoading:
        state => state.skipass.availablePassProducts.saveLoading,
      availablePassProductsSaveError: state => state.skipass.availablePassProducts.saveError,
      selectedBookingParticipantId:
        state => state.skipass.changeProduct.selectedBookingParticipantId,
      selectedPersonCategoryId: state => state.skipass.changeProduct.selectedPersonCategoryId,
      selectedStartDate: state => state.skipass.changeProduct.selectedStartDate,
      selectedNumberOfDays: state => state.skipass.changeProduct.selectedNumberOfDays,
      selectedSearchBookingParticipantId:
        state => state.skipass.search.selectedBookingParticipantId,
      selectedAreaId: state => state.skipass.search.selectedAreaId,
      areas: state => state.booking.areas.items,
      xmlProducts: state => state.twenty.xmlProducts.items,
    }),
    canChangeProduct() {
      return (this.isProductChanged || this.isPriceChanged)
        && (
          !this.isSearchingForAnotherProduct
          || (this.isSearchingForAnotherProduct
            && this.availableSkiPassProductUsedForChangeProduct
          )
        )
        && this.selectedPass.price !== undefined
        && this.selectedPass.priceNet !== undefined
        && this.selectedPersonCategoryId
        && this.selectedStartDate
        && this.selectedNumberOfDays;
    },
    loading() {
      return this.passLoading
        || this.passSaveLoading
        || this.booking.itemLoading
        || this.bookingParticipantsLoading;
    },
    errorOccurred() {
      return this.passError || this.booking.itemError || this.bookingParticipantsError;
    },
    filteredXmlProductsByXmlChannel() {
      if (this.selectedPass && this.selectedPass.xmlChannelId) {
        return this.xmlProducts.filter(xmlProduct => xmlProduct.xmlChannelId === this.selectedPass.xmlChannelId);
      }
      return this.xmlProducts;
    },
    filteredPasses() {
      return this.passes.filter(pass =>
        this.showInactive || (!pass.deletedAt && !pass.cancelledAt && !pass.stoppedAt),
      );
    },
  },
  methods: {
    ...mapActions({
      savePass: 'skipass/passUpdate',
      savePassPrice: 'skipass/passPriceUpdate',
      saveCancellationFeeNet: 'skipass/passCancellationFeeNetUpdate',
      savePassSupplierRef: 'skipass/passSupplierRefUpdate',
      savePassParticipant: 'skipass/passParticipantUpdate',
      deletePass: 'skipass/passDelete',
      stopPass: 'skipass/passStop',
      cancelPass: 'skipass/passCancel',
      reOpenPass: 'skipass/reOpen',
      loadAvailablePassPrices: 'skipass/availablePassPricesLoad',
      sendSkiPassRequestEmail: 'skipass/sendSkiPassRequestEmail',
      setChangeProductBookingParticipant: 'skipass/setChangeProductBookingParticipant',
      setChangeProductStartDate: 'skipass/setChangeProductStartDate',
      setChangeProductNumberOfDays: 'skipass/setChangeProductNumberOfDays',
      setChangeProductPersonCategory: 'skipass/setChangeProductPersonCategory',
      setBookingParticipant: 'skipass/setBookingParticipant',
      setStartDate: 'skipass/setStartDate',
      setNumberOfDays: 'skipass/setNumberOfDays',
      setArea: 'skipass/setArea',
      assignParticipant: 'skipass/assignParticipantToSkiPass',
      loadXmlChannels: 'twenty/xmlChannels',
      loadXmlProducts: 'twenty/xmlProducts',
      bookByXML: 'skipass/bookByXML',
      updateSupplierRefPubnub: 'skipass/updateSupplierRefPubnub',
    }),
    findXMLnames(skiPass) {
      return skiPass.skiPassPersonCategory.xmlChannelProductIds.map(
        (xmlChannelProductId) => {
          const xmlChannelProduct = this.xmlProducts.find(xmlProduct => xmlProduct.id === xmlChannelProductId);
          if (xmlChannelProduct) {
            return xmlChannelProduct.tbName;
          }
          return null;
        },
      ).join(', ');
    },
    updateSupplierRef(skiPass) {
      const supplierRef = this.supplierRefs[skiPass.id] ? this.supplierRefs[skiPass.id] : null;
      if (supplierRef !== skiPass.supplierRef) {
        this.savePassSupplierRef({ supplierRef, skiPass });
      } else {
        this.$set(this.supplierRefs, skiPass.id, skiPass.supplierRef);
      }
    },
    selectCurrentPass(pass) {
      this.selectedPass = Object.assign({}, pass);
    },
    deselectCurrentPass() {
      this.selectedPass = undefined;
      this.setBookingParticipant(null);
    },
    openEditProductDialog(pass) {
      this.selectCurrentPass(pass);
      this.isPriceChanged = false;
      this.isProductChanged = false;
      this.isXmlProductChanged = false;
      this.isSearchingForAnotherProduct = false;
      if (pass.participant) {
        this.setChangeProductBookingParticipant(pass.participant.id);
        this.setBookingParticipant(pass.participant.id);
      }
      if (!this.selectedStartDate) {
        this.setChangeProductStartDate(this.defaultStartDate);
      }
      this.setStartDate(this.selectedStartDate || this.defaultStartDate);
      this.setNumberOfDays(pass.numberOfDays);
      this.setChangeProductPersonCategory(pass.productsSkiPassPersonCategoryId);
      this.setChangeProductNumberOfDays(pass.numberOfDays);
      this.editProductDialog = true;
    },
    async saveProductDialog() {
      let closeDiaLog = false;
      this.setKeyCardPricesOnSelectedPass();
      this.setGrossNetPricesOnSelectedPass();
      if (this.isSearchingForAnotherProductAndProductChanged()) {
        const newProduct = this.availableSkiPassProductUsedForChangeProduct;
        const ageTranslation = this.$t('ski.pass.years-from-to', {
          from: newProduct.personCategory.ageFrom,
          to: newProduct.personCategory.ageTo,
        });
        const personCategoryAges = `(${ageTranslation})`;
        const changedProduct = {
          id: this.selectedPass.id,
          bookingId: this.selectedPass.bookingId,
          areaId: this.selectedPass.areaId,
          bookingParticipantId: this.selectedPass.bookingParticipantId,
          priceUserAgentId: this.isPriceChanged ? this.user.id : null,
          cancelledUserAgentId: null,
          productsSkiPassSeasonId: newProduct.season.id,
          productsSkiPassPersonCategoryId: newProduct.personCategory.id,
          status: statusEnums.INITIATED,
          salesType: salesTypeEnums.BOOKING,
          supplierRef: null,
          firstSkiDay: this.selectedStartDate,
          numberOfDays: newProduct.days,
          price: this.$options.filters.roundNumber(this.editProductPrices.price),
          priceNet: this.$options.filters.roundNumber(this.editProductPrices.priceNet),
          keyCardPrice: this.editProductPrices.keyCardGross,
          keyCardPriceNet: this.editProductPrices.keyCardNet,
          currencyNet: newProduct.season.supplier.currency,
          supplierName: newProduct.season.supplier.name,
          seasonName: newProduct.season.name,
          personCategoryName: newProduct.personCategory.name + personCategoryAges,
          seasonNameSupplier: newProduct.season.name,
          personCategoryNameSupplier: newProduct.personCategory.externalName
            + personCategoryAges,
          discount: this.editProductPrices.discount,
          discountNet: this.editProductPrices.discountNet,
          discountBookFrom: this.editProductPrices.discountBookFrom,
          discountBookTo: this.editProductPrices.discountBookTo,
        };

        closeDiaLog = await this.savePass({
          changedProduct,
          bookingId: this.booking.id,
        });
      } else if (this.isPriceChanged) {
        const changedProductPrice = {
          id: this.selectedPass.id,
          priceUserAgentId: this.user.id,
          price: this.editProductPrices.price,
          priceNet: this.editProductPrices.priceNet,
          keyCardPrice: this.editProductPrices.keyCardGross,
          keyCardPriceNet: this.editProductPrices.keyCardNet,
          currencyNet: this.selectedPass.currencyNet,
        };
        closeDiaLog = await this.savePassPrice({
          changedProductPrice,
          bookingId: this.booking.id,
        });
      }

      if (this.selectedPass.cancellationFeeNet && this.selectedPass.cancellationFeeNet.length) {
        closeDiaLog = await this.saveCancellationFeeNet({
          skiPassId: this.selectedPass.id,
          cancellationFeeNet: this.selectedPass.cancellationFeeNet && this.selectedPass.cancellationFeeNet.length
            ? this.$options.filters.roundNumber(this.selectedPass.cancellationFeeNet)
            : 0,
          bookingId: this.booking.id,
        });
      }

      if (closeDiaLog && !this.passSaveError) {
        this.editProductDialog = false;
        this.deselectCurrentPass();
      }
    },
    closeProductDialog() {
      this.editProductDialog = false;
      this.selectedArea = undefined;
      this.isSearchingForAnotherProduct = false;
      this.deselectCurrentPass();
    },
    isSearchingForAnotherProductAndProductChanged() {
      return this.isSearchingForAnotherProduct
        && this.isProductChanged
        && this.availableSkiPassProductUsedForChangeProduct;
    },
    setGrossNetPricesOnSelectedPass() {
      let price;
      let priceNet;
      let discount = null;
      let discountNet = null;
      let discountBookFrom = null;
      let discountBookTo = null;
      if (this.isSearchingForAnotherProductAndProductChanged()) {
        const newProduct = this.availableSkiPassProductUsedForChangeProduct;
        price = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          newProduct.priceGross,
        ));
        priceNet = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          newProduct.priceNet,
        ));
        if (newProduct.discount && newProduct.discount.id) {
          discount = this.$options.filters.roundNumber(newProduct.discountGross);
          discountNet = this.$options.filters.roundNumber(newProduct.discountNet);
          discountBookFrom = newProduct.discount.bookFrom;
          discountBookTo = newProduct.discount.bookTo;
        }
        if (this.isPriceChanged) {
          price = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
            this.selectedPass.totalGrossAfterDiscount,
          ));
          priceNet = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
            this.selectedPass.totalNetAfterDiscount,
          ));
          if (discount && discountNet) {
            price += discount;
            priceNet += discountNet;
          }
        }
      } else if (this.isPriceChanged) {
        price = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          this.selectedPass.totalGrossAfterDiscount,
        ));
        priceNet = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          this.selectedPass.totalNetAfterDiscount,
        ));
        if (this.selectedPass.discount && this.selectedPass.discountNet) {
          price += this.$options.filters.roundNumber(this.selectedPass.discount);
          priceNet += this.$options.filters.roundNumber(this.selectedPass.discountNet);
        }
      }
      this.editProductPrices.price = price;
      this.editProductPrices.priceNet = priceNet;
      this.editProductPrices.discount = discount;
      this.editProductPrices.discountNet = discountNet;
      this.editProductPrices.discountBookFrom = discountBookFrom;
      this.editProductPrices.discountBookTo = discountBookTo;
    },
    setKeyCardPricesOnSelectedPass() {
      let keyCardGross = null;
      let keyCardNet = null;
      if (this.selectedPass.hasKeyCard) {
        keyCardGross = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          this.selectedPass.keyCardGross,
        ));
        keyCardNet = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          this.selectedPass.keyCardNet,
        ));
      }
      this.editProductPrices.keyCardGross = keyCardGross;
      this.editProductPrices.keyCardNet = keyCardNet;
    },
    stopProductDialog(skiPassId) {
      this.stopPass({ skiPassId, salesAgentUserId: this.user.id, bookingId: this.booking.id });
    },
    reOpenProductDialog(skiPassId) {
      this.reOpenPass({
        skiPassId,
        bookingId: this.booking.id,
        status: statusEnums.INITIATED,
      });
    },
    searchAvailableProducts() {
      this.isSearchingForAnotherProduct = true;
      const areaId = this.selectedArea || this.defaultAreaId;
      this.loadAvailablePassPrices({
        areaId,
        numberOfDays: this.selectedNumberOfDays,
        participantAge: this.selectedPass.participant.age,
        skiStartDayDate: this.selectedStartDate,
        targetCurrency: this.booking.currency,
      });
    },
    takeGrossNetPrice(availableSkiPassProduct) {
      this.isProductChanged = true;
      this.selectedPass.totalGrossAfterDiscount
        = this.$options.filters.roundNumber(availableSkiPassProduct.totalGrossAfterDiscount);
      this.selectedPass.totalNetAfterDiscount
        = this.$options.filters.roundNumber(availableSkiPassProduct.totalNetAfterDiscount);
      this.selectedPass.price
        = this.$options.filters.roundNumber(availableSkiPassProduct.priceGross);
      this.selectedPass.priceNet
        = this.$options.filters.roundNumber(availableSkiPassProduct.priceNet);
      this.selectedPass.keyCardGross = availableSkiPassProduct.keyCardGross;
      this.selectedPass.keyCardNet = availableSkiPassProduct.keyCardNet;
      this.selectedPass.currencyNet = availableSkiPassProduct.season.supplier.currency;
      this.selectedPass.discount = null;
      this.selectedPass.discountNet = null;
      this.selectedPass.discountBookFrom = null;
      this.selectedPass.discountBookTo = null;
      this.selectedPass.discountPercentage = null;
      if (availableSkiPassProduct.discountGross) {
        this.selectedPass.discount
          = this.$options.filters.roundNumber(availableSkiPassProduct.discountGross);
        this.selectedPass.discountNet
          = this.$options.filters.roundNumber(availableSkiPassProduct.discountNet);
        this.selectedPass.discountBookFrom = availableSkiPassProduct.discount.bookFrom;
        this.selectedPass.discountBookTo = availableSkiPassProduct.discount.bookTo;
        this.selectedPass.discountPercentage = availableSkiPassProduct.discount.percentage;
      }
    },
    sendRequestEmail() {
      this.sendSkiPassRequestEmail(this.booking.id);
    },
    previewRequestEmail() {
      return `${process.env.TWENTY_API_URL}booking/ski/pass/booking/${this.booking.id}/preview-supplier-request`;
    },
    onStartDateChange(startDate) {
      this.setChangeProductStartDate(startDate);
      this.searchAvailableProducts();
    },
    onNumberOfDaysChange(days) {
      this.setChangeProductNumberOfDays(days);
      this.searchAvailableProducts();
    },
    onAreaChange(areaId) {
      this.selectedArea = areaId;
      this.searchAvailableProducts();
    },
    onPersonCategoryChange(personCategoryId) {
      this.setChangeProductPersonCategory(personCategoryId);
    },
    onPriceOverrideChange() {
      this.isPriceChanged = true;
    },
    onFilterAreaChange(areaId) {
      this.setArea(areaId);
    },
    onBookingParticipantChange(participantId) {
      this.setBookingParticipant(participantId);
    },
    openConfirmDialog(type) {
      const vueComponent = this.$refs[type];
      if (vueComponent instanceof Array) {
        vueComponent[0].open();
      } else {
        vueComponent.open();
      }
    },
    assignParticipantToSkiPass(participantId, skiPassId) {
      this.assignParticipant({ participantId, skiPassId });
    },
    XMLBookTooltip(pass) {
      const tooltip = [];

      if (this.findXMLnames(pass) === '') {
        tooltip.push('No XML products mapped');
      }

      if (pass.statusName !== 'paid') {
        tooltip.push('Booking not paid');
      }

      if (pass.supplierRef != null) {
        tooltip.push('Supplier ref already set');
      }

      if (!pass.bookableByXML) {
        tooltip.push('Not bookable by XML');
      }

      return tooltip.join(', ');
    },
  },
};
</script>

<template>
  <v-container v-if="booking && booking.id" class="pa-0 pt-3" grid-list-xl>
    <div class="text-center pa-1">
      <v-progress-linear v-if="loading" indeterminate/>
    </div>
    <v-card
      class="pa-3 mb-3 mx-auto"
      outlined
    >
      <v-layout class="pt-3 pl-3 pr-3">
        <v-flex class="ma-0 pa-0" sm5 xs12>
          <v-select
            @change="onBookingParticipantChange($event)"
            :value="selectedSearchBookingParticipantId"
            :items="bookingParticipantsWherePassExist"
            :disabled="bookingParticipantsLoading || !bookingParticipantsWherePassExist.length"
            :label="$t('ski.pass.selects.booking-participant')"
            item-text="fullName"
            item-value="id"
          />
        </v-flex>
        <div class="ml-4">
          <p class="text-center">Show inactive passes</p>
          <v-checkbox v-model="showInactive"/>
        </div>
        <v-flex v-if="areas.length > 1" class="pl-2 ma-0 pa-0" sm2 xs12>
          <v-select
            @change="onFilterAreaChange($event)"
            :value="selectedAreaId"
            :items="areasWithAllOption"
            :disabled="!bookingParticipantsWherePassExist.length"
            :label="$t('ski.pass.selects.area')"
            item-text="name"
            item-value="id"
          />
        </v-flex>
      </v-layout>
    </v-card>
    <v-alert
      v-if="!passes.length && !this.booking.itemLoading && !this.bookingParticipantsLoading"
      color="warning"
      icon="info"
      outline
    >
      {{ $t('ski.pass.no-ski-pass-exist-on-this-booking') }}
    </v-alert>
    <div
      v-for="pass in filteredPasses"
      :key="pass.id"
      class="py-2"
    >
      <v-layout class="pb-0 mb-0" row>
        <v-flex class="pb-0 mb-0" sm4 xs12>
          <h2 class="font-weight-bold">
            <template v-if="pass.participant">
              {{ pass.participant.firstName }} {{ pass.participant.lastName }}
            </template>
            <template v-else>
              No Participant
            </template>
            <template v-if="areas.length > 1">
              ({{ pass.area.name }})
            </template>
          </h2>
          <div v-if="pass.ageMismatch">
            <v-icon class="red--text" title="Missing height">warning</v-icon>
            <span class="red--text">{{ $t('ski.pass.age-mismatch') }}</span>
          </div>
        </v-flex>
        <v-flex class="pb-0 mb-0 text-md-center" sm2 xs3>
          <v-chip v-if="!pass.deletedAt" :color="pass.statusColor" text-color="white" disabled>
            {{ pass.statusName }}
            <v-icon right>{{ pass.statusIcon }}</v-icon>
          </v-chip>
          <v-chip v-else color="red" text-color="white" disabled>
            Deleted
            <v-icon right>warning</v-icon>
          </v-chip>
        </v-flex>
        <v-flex class="pb-0 mb-0 no-wrap" sm2 xs12>
          <template v-if="pass.discount">
            <h2>
              {{ pass.totalGrossAfterDiscount }} {{ booking.currency }}
              <span class="blue-grey--text caption">
                <template v-if="pass.cancellationFeeNet !== null">
                  / {{ pass.cancellationFeeNet }} {{ pass.currencyNet }}
                </template>
                <template v-else>
                  / {{ pass.totalNetAfterDiscount }} {{ pass.currencyNet }}
                </template>
              </span>
              <v-chip color="green" text-color="white" disabled>
                -{{ (pass.discount / pass.price) * 100 | roundNumber }}%
              </v-chip>
            </h2>
          </template>
          <template v-else>
            <h2>
              {{ pass.price }} {{ booking.currency }}
              <span class="blue-grey--text body-2 caption">
                / {{ pass.priceNet }} {{ pass.currencyNet }}
              </span>
            </h2>
          </template>
          <span
            v-if="pass.priceUserAgentId"
            class="red--text"
            :title="pass.priceUserAgentId"
          >
            {{ $t('ski.pass.price-modified') }}
          </span>
        </v-flex>
        <v-flex class="pb-0 mb-0 ml-auto text-md-right no-wrap" sm3 xs0>
          <v-btn
            @click.stop="openEditProductDialog(pass)"
            :disabled="loading"
            color="warning"
            small
          >
            {{ $t('inputs.actions.edit') }}
          </v-btn>
          <template v-if="['stopped', 'cancelled'].includes(pass.status) || pass.deletedAt">
            <v-btn
              @click="openConfirmDialog(`confirm-reopen-dialog-${pass.id}`)"
              :disabled="loading"
              color="error"
              small
            >
              {{ $t('inputs.actions.reopen') }}
            </v-btn>
            <confirm-dialog
              @confirm="reOpenProductDialog(pass.id)"
              :title="$t('ski.pass.confirm-title')"
              :description="$t('ski.pass.reopenAreYouSure')"
              :ref="'confirm-reopen-dialog-' + pass.id"
            >
            </confirm-dialog>
          </template>
          <template v-else>
            <v-btn
              v-if="pass.supplierRef"
              @click="openConfirmDialog('confirm-stop-dialog-' + pass.id)"
              :disabled="loading"
              color="error"
              small
            >
              {{ $t('inputs.actions.stop') }}
            </v-btn>
            <v-btn
              v-else
              @click="openConfirmDialog('confirm-delete-dialog-' + pass.id)"
              :disabled="loading"
              color="error"
              small
            >
              {{ $t('inputs.actions.delete') }}
            </v-btn>
            <confirm-dialog
              @confirm="stopProductDialog(pass.id)"
              :title="$t('ski.pass.confirm-title')"
              :description="$t('ski.pass.deleteAreYouSure')"
              :ref="'confirm-delete-dialog-' + pass.id"
            >
            </confirm-dialog>
            <confirm-dialog
              @confirm="stopProductDialog(pass.id)"
              :title="$t('ski.pass.confirm-title')"
              :description="$t('ski.pass.stopAreYouSure')"
              :ref="'confirm-stop-dialog-' + pass.id"
            >
            </confirm-dialog>
            <confirm-dialog
              @confirm="stopProductDialog(pass.id)"
              :title="$t('ski.pass.confirm-title')"
              :description="$t('ski.pass.cancelAreYouSure')"
              :ref="'confirm-cancel-dialog-' + pass.id"
            >
            </confirm-dialog>
          </template>
        </v-flex>
      </v-layout>
      <v-layout class="no-wrap" row>
        <v-flex class="font-weight-bold py-0 mb-0" sm6 xs12>
          {{ pass.personCategoryName }}
        </v-flex>
        <v-flex v-if="pass.discount" class="py-0 mb-0" sm6 xs12>
          <p class="text-line-through mb-0 pa-0">
            {{ pass.price }} {{ booking.currency }}
            <span class="blue-grey--text body-2 caption">
              / {{ pass.priceNet }} {{ pass.currencyNet }}
            </span>
          </p>
        </v-flex>
      </v-layout>
      <v-layout class="no-wrap" row>
        <v-flex class="font-weight-bold py-0 mb-0" sm6 xs12>
          <span v-if="pass.hasKeyCard">
            {{ $t('ski.pass.pass-incl-key-card') }}
          </span>
          <span v-else>
            {{ $t('ski.pass.pass-excl-key-card') }}
          </span>
        </v-flex>
        <v-flex v-if="pass.hasKeyCard" class="py-0 mb-0" sm6 xs12>
          <p class="font-weight-bold mb-0 pa-0">
            <template v-if="pass.keyCardGross > 0">
              +
            </template>
            {{ pass.keyCardGross }} {{ booking.currency }}
            <span class="blue-grey--text body-2 caption">
              / {{ pass.keyCardNet }} {{ pass.currencyNet }}
            </span>
          </p>
        </v-flex>
      </v-layout>
      <v-layout class="no-wrap" row>
        <v-flex class="pb-0 mb-0" sm3 xs12>
          {{ $t('ski.pass.first-ski-day') }}:
          <span class="font-weight-bold">{{ pass.firstSkiDay | formatDate }}</span>
        </v-flex>
        <v-flex class="pb-0 mb-0" sm6 xs12>
          {{ $t('ski.pass.number-of-days') }}:
          <span class="font-weight-bold">
            {{ pass.numberOfDays }} {{ $t('ski.pass.days') }}
          </span>
        </v-flex>
        <v-flex class="py-0 my-0 text-md-right" sm3 xs12>
          <v-text-field
            @blur="updateSupplierRef(pass)"
            v-model="supplierRefs[pass.id]"
            :disabled="passSaveLoading"
            :label="$t('ski.pass.supplier-ref')"
            :success="!!pass.supplierRef"
            :error="!pass.supplierRef"
            :append-outer-icon="pass.supplierRef ? 'check_circle' : 'warning'"
            type="text"
            class="py-0 my-0"
            hide-details
          />
        </v-flex>
      </v-layout>
      <v-layout class="no-wrap" row>
        <div v-if="pass.participant">
          <v-flex class="pb-0 mb-0" sm12 xs12>
            {{ $t('ski.pass.birthday') }}:
            <span
              v-if="pass.participant.validBirthday"
              class="font-weight-bold"
            >
              {{ pass.participant.birthday | formatDate }}
              ({{ pass.participant.age }} {{ $t('ski.pass.years-old') }})
              <v-icon class="green--text">
                check_circle
              </v-icon>
            </span>
            <span v-else class="font-weight-bold">
            {{ pass.participant.age }} {{ $t('ski.pass.years-old') }}
            <v-icon class="red--text">warning</v-icon>
            <a :href="twentyBookingCustomerUrl" target="_blank" class="red--text">
              {{ $t('ski.pass.birthday-not-verified') }}
            </a>
          </span>
          </v-flex>
          <v-flex class="pb-0 mb-0 sm5 xs5" style="text-wrap: balance">
            {{ findXMLnames(pass) }}
          </v-flex>
          <v-flex class="pb-0 mb-0 sm5 xs5">
            <v-tooltip v-if="XMLBookTooltip(pass).length" top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-btn
                    v-if="XMLBookTooltip(pass).length"
                    :disabled="loading || !!XMLBookTooltip(pass).length"
                    color="success"
                    small
                    @click="bookByXML(pass)"
                  >
                    Book by XML
                  </v-btn>
                </span>
              </template>
              <span>
                {{ XMLBookTooltip(pass) }}
              </span>
            </v-tooltip>
            <v-btn
              v-else
              :disabled="loading || !!XMLBookTooltip(pass).length"
              color="success"
              small
              @click="bookByXML(pass)"
            >
              Book by XML
            </v-btn>
          </v-flex>
        </div>
        <v-flex v-else-if="pass.cancelledAt === null && pass.stoppedAt === null" xs3>
        <v-select
          :items="participants"
          :label="'Select participant'"
          item-text="fullName"
          item-value="id"
          @change="assignParticipantToSkiPass($event, pass.id)"
        />
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
    </div>
    <v-layout
      v-if="passes.length && !this.booking.itemLoading && !this.bookingParticipantsLoading"
      class="no-wrap pt-3"
      row
    >
      <v-flex class="ma-0 pa-0 text-md-right" sm8 xs12>
        <a
          :href="previewRequestEmail()"
          target="_blank"
          class="v-btn theme--dark success"
        >
          Preview request
        </a>
        <v-btn
          @click="sendRequestEmail"
          :disabled="loading"
          color="success"
        >
          {{ $t('ski.pass.send-request-email') }}
        </v-btn>
      </v-flex>
      <v-flex class="ma-0 pa-0 text-md-center" sm4 xs4>
        <h1 class="text-uppercase">
          {{ $t('ski.pass.total') }} {{ totalPrice.totalGross }} {{ booking.currency }}
          <span class="blue-grey--text caption">
            / {{ totalPrice.totalNet }}
          </span>
        </h1>
      </v-flex>
    </v-layout>
    <v-dialog
      v-if="selectedPass"
      v-model="editProductDialog"
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <div class="headline">
            {{ $t('ski.pass.products-information-for', {
              first: this.selectedPass.participant ? this.selectedPass.participant.firstName : 'No participant',
              last: this.selectedPass.participant ? this.selectedPass.participant.lastName : ''
            }) }}
            <span class="body-2">
              {{ selectedPass.personCategoryName }}
            </span>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3 mt-0">
          <v-container class="pt-0 mt-0" grid-list-md>
            <v-alert
              v-if="passSaveError"
              :value="passSaveError"
              color="error"
              icon="warning"
              outline
            >
              <span v-html="passSaveError"></span>
            </v-alert>
            <v-layout wrap>
              <v-flex class="pt-0 mt-0" xs12 sm12 md12>
                <h2>
                  {{ $t('ski.pass.override-prices') }}
                  <v-chip v-if="isPriceChanged" color="red" text-color="white" disabled>
                    {{ $t('ski.pass.price-modified-and-not-saved-yet') }}
                  </v-chip>
                </h2>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="selectedPass.totalGrossAfterDiscount"
                  @input="onPriceOverrideChange"
                  :suffix="booking.currency"
                  :disabled="loading
                  || bookingParticipantsLoading
                  || availablePassProductsLoading
                  || selectedPass.status === 'paid'
                  "
                  :label="$t('ski.pass.price-gross')"
                  required
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="selectedPass.totalNetAfterDiscount"
                  @input="onPriceOverrideChange"
                  :suffix="selectedPass.currencyNet"
                  :disabled="loading
                  || bookingParticipantsLoading
                  || availablePassProductsLoading
                  || selectedPass.cancelledAt !== null
                  || selectedPass.stoppedAt !== null
                  "
                  :label="$t('ski.pass.price-net')"
                  required
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="selectedPass.cancellationFeeNet"
                  @input="onPriceOverrideChange"
                  :suffix="selectedPass.currencyNet"
                  :disabled="loading || (!selectedPass.cancelledAt && !selectedPass.stoppedAt)"
                  :label="$t('ski.pass.cancellation-fee-net')"
                  placeholder="0"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="selectedPass.keyCardGross"
                  @input="onPriceOverrideChange"
                  :suffix="booking.currency"
                  :disabled="loading
                  || bookingParticipantsLoading
                  || availablePassProductsLoading
                  || selectedPass.status === 'paid'"
                  :label="$t('ski.pass.key-card-price-gross')"
                  required
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="selectedPass.keyCardNet"
                  @input="onPriceOverrideChange"
                  :suffix="selectedPass.currencyNet"
                  :disabled="loading
                  || bookingParticipantsLoading
                  || availablePassProductsLoading
                  || selectedPass.cancelledAt !== null
                  || selectedPass.stoppedAt !== null"
                  :label="$t('ski.pass.key-card-price-net')"
                  required
                />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <h2>
                  Change product
                  <v-chip v-if="isProductChanged" color="red" text-color="white" disabled>
                    {{ $t('ski.pass.product-modified-and-not-saved-yet') }}
                  </v-chip>
                </h2>
              </v-flex>
              <v-flex class="text-xs-right" xs12 sm3>
                <v-select
                  @change="onStartDateChange($event)"
                  :value="selectedPass.firstSkiDay"
                  :items="availableDates"
                  :disabled="bookingParticipantsLoading || availablePassProductsLoading"
                  label="Select start date"
                  item-text="name"
                  item-value="id"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-select
                  @change="onNumberOfDaysChange($event)"
                  :value="selectedPass.numberOfDays"
                  :items="availableNumberOfDays"
                  :disabled="bookingParticipantsLoading || availablePassProductsLoading"
                  label="Select number of days"
                />
              </v-flex>
              <v-flex v-if="areas.length > 1" sm2 xs12>
                <v-select
                  @change="onAreaChange($event)"
                  :value="defaultAreaId || null"
                  :items="areas"
                  :disabled="bookingParticipantsLoading || availablePassProductsLoading"
                  :label="$t('ski.pass.selects.area')"
                  item-text="name"
                  item-value="id"
                />
              </v-flex>
              <v-flex xs12 sm4>
                <v-btn
                  @click="searchAvailableProducts"
                  :disabled="availablePassProductsLoading"
                  color="warning"
                >
                  Search product
                </v-btn>
              </v-flex>
              <template
                v-if="isSearchingForAnotherProduct && Object.keys(availablePassProducts).length"
              >
                <v-flex xs12 sm3>
                  <v-select
                    @change="onPersonCategoryChange($event)"
                    :items="availablePassProductsPersonCategoryHeaders"
                    :disabled="loading || availablePassProductsLoading"
                    :value="selectedPass.productsSkiPassPersonCategoryId"
                    :label="$t('ski.pass.selects.person-category')"
                    item-text="name"
                    item-value="id"
                    required
                  />
                </v-flex>
              </template>
              <template v-if="isSearchingForAnotherProduct">
                <template v-if="availableSkiPassProductUsedForChangeProduct">
                  <v-flex xs12 sm12>
                    <h3>{{ $t('ski.pass.available-product-and-price-found') }}</h3>
                  </v-flex>
                  <template v-if="availableSkiPassProductUsedForChangeProduct.hasKeyCard">
                    <v-flex class="font-weight-bold py-0 mb-0" sm3 xs12>
                      <span v-if="availableSkiPassProductUsedForChangeProduct.hasKeyCard">
                        {{ $t('ski.pass.incl-key-card') }}
                      </span>
                      <span v-else>
                        {{ $t('ski.pass.excl-key-card') }}
                      </span>
                    </v-flex>
                    <v-flex
                      v-if="availableSkiPassProductUsedForChangeProduct.hasKeyCard"
                      class="py-0 mb-0"
                      sm9
                      xs12
                    >
                      <p class="font-weight-bold mb-0 pa-0">
                        {{ availableSkiPassProductUsedForChangeProduct.keyCardGross }}
                        {{ booking.currency }}
                        <span class="blue-grey--text body-2 caption">
                          / {{ availableSkiPassProductUsedForChangeProduct.keyCardNet }}
                          {{ availableSkiPassProductUsedForChangeProduct.season.supplier.currency }}
                        </span>
                      </p>
                    </v-flex>
                  </template>
                  <template v-if="availableSkiPassProductUsedForChangeProduct.discountGross">
                    <v-flex xs12 sm3>
                      <p class="font-weight-bold pb-0 mb-0">
                        {{ $t('ski.pass.price-before-discount') }}:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm9>
                      <p class="font-weight-bold pb-0 mb-0">
                        {{ availableSkiPassProductUsedForChangeProduct.priceGross }}
                        {{ booking.currency }}
                        <span class="blue-grey--text body-2 caption">
                          / {{ availableSkiPassProductUsedForChangeProduct.priceNet }}
                          {{
                            availableSkiPassProductUsedForChangeProduct.season.supplier.currency
                          }}
                        </span>
                      </p>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <p class="font-weight-bold pb-0 mb-0">
                        {{ $t('ski.pass.discount') }}:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm9>
                      <p class="font-weight-bold pb-0 mb-0">
                        -{{ availableSkiPassProductUsedForChangeProduct.discountGross }}
                        {{ booking.currency }}
                        <span class="blue-grey--text body-2 caption">
                          / -{{ availableSkiPassProductUsedForChangeProduct.discountNet }}
                          {{
                            availableSkiPassProductUsedForChangeProduct.season.supplier.currency
                          }}
                        </span>
                      </p>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <p class="font-weight-bold pb-0 mb-0">
                        {{ $t('ski.pass.total-after-discount') }}:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm9>
                      <p class="font-weight-bold pb-0 mb-0">
                        {{ availableSkiPassProductUsedForChangeProduct.totalGrossAfterDiscount }}
                        {{ booking.currency }}
                        <span class="blue-grey--text body-2 caption">
                          /
                          {{ availableSkiPassProductUsedForChangeProduct.totalNetAfterDiscount }}
                          {{
                            availableSkiPassProductUsedForChangeProduct.season.supplier.currency
                          }}
                        </span>
                      </p>
                    </v-flex>
                  </template>
                  <template v-else>
                    <v-flex xs12 sm3>
                      <p class="font-weight-bold pb-0 mb-0">
                        {{ $t('ski.pass.total') }}:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm9>
                      <p class="font-weight-bold pb-0 mb-0">
                        {{ availableSkiPassProductUsedForChangeProduct.totalGrossAfterDiscount }}
                        {{ booking.currency }}
                        <span class="blue-grey--text body-2 caption">
                          / {{ availableSkiPassProductUsedForChangeProduct.totalNetAfterDiscount }}
                          {{
                            availableSkiPassProductUsedForChangeProduct.season.supplier.currency
                          }}
                        </span>
                      </p>
                    </v-flex>
                  </template>
                  <v-flex xs12 sm12>
                    <v-btn
                      @click="takeGrossNetPrice(availableSkiPassProductUsedForChangeProduct)"
                      :disabled="availablePassProductsLoading"
                      color="warning"
                    >
                      {{ $t('ski.pass.take-gross-net-price') }}
                    </v-btn>
                  </v-flex>
                </template>
                <template v-else>
                  <h3 v-if="!availablePassProductsLoading" class="red--text">
                    {{ $t('ski.pass.no-available-price-found') }}
                  </h3>
                </template>
              </template>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="closeProductDialog"
            :disabled="loading"
            color="red darken-1"
            flat
          >
            {{ $t('dialog.actions.close') }}
          </v-btn>
          <v-btn
            @click="openConfirmDialog('confirm-save-product-dialog')"
            :disabled="(!canChangeProduct || loading || availablePassProductsSaveLoading) && !isXmlProductChanged"
            color="green darken-1"
            flat
          >
            {{ $t('dialog.actions.save') }}
          </v-btn>
          <confirm-dialog
            @confirm="saveProductDialog"
            :title="$t('ski.pass.confirm-title')"
            :description="$t('ski.pass.saveAreYouSure')"
            ref="confirm-save-product-dialog"
          >
          </confirm-dialog>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/booking/ski/pass/SkiPassOverview.vue